module.exports = __webpack_public_path__ + "static/media/splashScreen.41cd5d3e.svg";